import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ARTICLE_POSTS } from '../../data/ArticlesData';

const ArticleLayout = ({ articleId, children }) => {
  const articleIndex = ARTICLE_POSTS.findIndex((post) => post.id === articleId);
  const article = articleIndex >= 0 ? ARTICLE_POSTS[articleIndex] : null;
  const prevArticle = articleIndex > 0 ? ARTICLE_POSTS[articleIndex - 1] : null;
  const nextArticle = articleIndex < ARTICLE_POSTS.length - 1 ? ARTICLE_POSTS[articleIndex + 1] : null;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [articleId]);

  if (!article) {
    return (
      <section className="sec-mar">
        <div className="container">
          <h2>Article not found</h2>
          <p>
            The article you requested could not be located.{' '}
            <Link to="/articles">Return to the insights hub</Link>.
          </p>
        </div>
      </section>
    );
  }

  const bodyContent =
    children && React.Children.count(children) > 0
      ? children
      : (article.content || []).map((paragraph, idx) => <p key={idx}>{paragraph}</p>);

  return (
    <>
      <section className="breadcrumbs">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb-wrapper">
                <div className="breadcrumb-cnt">
                  <span>Article Details</span>
                  <h1>{article.title}</h1>
                  <div className="breadcrumb-list">
                    <Link to="/">Home</Link>
                    <img src="/assets/img/content/breadcrumb-arrow.svg" alt="" /> Article Details
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="bolog-details-area sec-mar">
        <div className="container">
          <div className="row g-lg-4 gy-5">
            <div className="col-lg-8">
              <div className="blog-details-content">
                <span>{article.category}</span>
                <h2>{article.title}</h2>

                <div className="author-and-meta">
                  <div className="author-area">
                    <div className="author-img">
                      <img src="/assets/img/content/blog-dt-author.png" alt="Nalexus Technologies Author" />
                    </div>
                    <div className="author-content">
                      <h6>By, <span>{article.author}</span></h6>
                    </div>
                  </div>
                  <ul className="blog-meta">
                    <li><i className="bi bi-clock"></i>{article.date}</li>
                  </ul>
                </div>

                <p className="lead">{article.description}</p>
                <div className="article-rich-text">
                  {bodyContent}
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="widget-area">
                <div className="single-widgets widget_search">
                  <Link className="primary-btn3" to="/articles">Browse all insights</Link>
                </div>

                <div className="single-widgets widget_egns_categoris">
                  <div className="widget-title"><h4>Category</h4></div>
                  <ul className="wp-block-categoris-cloud">
                    {Array.from(new Set(ARTICLE_POSTS.map((post) => post.category))).map((category) => {
                      const count = ARTICLE_POSTS.filter((p) => p.category === category).length;
                      return (
                        <li key={category}>
                          <Link to={`/articles?category=${encodeURIComponent(category)}`}>
                            <span>{category}</span><span>({count})</span>
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>

                <div className="single-widgets widget_egns_recent_post">
                  <div className="widget-title"><h4>Newest Posts</h4></div>
                  <div className="recent-post-wraper">
                    {ARTICLE_POSTS.slice(-3).reverse().map((post) => (
                      <div className="widget-cnt" key={post.id}>
                        <div className="wi">
                          <Link to={`/articles/${post.id}`}><img src={post.img} alt={post.title} /></Link>
                        </div>
                        <div className="wc">
                          <h6><Link to={`/articles/${post.id}`}>{post.title}</Link></h6>
                          <Link to={`/articles/${post.id}`}>{post.date}</Link>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="details-navigation">
                {prevArticle && (
                  <div className="single-navigation">
                    <div className="content">
                      <span>Previous</span>
                      <h4><Link to={`/articles/${prevArticle.id}`}>{prevArticle.title}</Link></h4>
                    </div>
                    <Link to={`/articles/${prevArticle.id}`} className="img">
                      <img src={prevArticle.img} alt={prevArticle.title} />
                      <div className="arrow"><svg><path d="M0 1H12M12 1V13M12 1L0.5 12" /></svg></div>
                    </Link>
                  </div>
                )}
                {nextArticle && (
                  <div className="single-navigation two">
                    <Link to={`/articles/${nextArticle.id}`} className="img">
                      <img src={nextArticle.img} alt={nextArticle.title} />
                      <div className="arrow"><svg><path d="M0 1H12M12 1V13M12 1L0.5 12" /></svg></div>
                    </Link>
                    <div className="content">
                      <span>Next</span>
                      <h4><Link to={`/articles/${nextArticle.id}`}>{nextArticle.title}</Link></h4>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default ArticleLayout;

